module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAtUlEQVQokX3OMU4CQRQG4I9hKagtvIAF8QoUhIR27CwNR7CnUUNBCzSwjQcgxMTExHAUbuABpCAkajMmA9nd102+ee//W2VZjtHF2vkEPNSYgG+s8Jw+/c9Pg2nHGPc4YopbfKY31FpIl2e4xwg79LLUSgtZ+hYDdPCBYZO1Y4x59S+cMEaBd/xWWZ54jTlescEkVa20IkHEC27wiGV2sNIC7vCWqvQvlmqtwBWesMAhWwoN5g8j1zaFL5axfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/icons/icon_arrow_right.png
// module id = Y1nK
// module chunks = 0